import { gql } from '@apollo/client';

export const GET_CLIENT_EXTRACT = gql`
  query extratoCliente(
    $id: ID!
    $period: dateFilter!
    $fidelityMethod: FIDELITY_METHOD_INPUT!
  ) {
    client(_id: $id) {
      _id
      extract(period: $period, fidelityMethod: $fidelityMethod) {
        _id
        company
        date
        fidelityMethod
        manualInserted
        OBS
        padrao
        type
        value
        voucher
        expirationDate
        used
        expired
        expiredValue
      }
    }
  }
`;

export const GET_RESUME_SUPPLYS_EXTRACT = gql`
  query extrato(
    $client: ID!
    $DateStart: Date
    $DateEnd: Date
    $orderByAscending: Boolean
    $fidelityMethod: FIDELITY_METHOD_INPUT
  ) {
    resumeSupplysExtract(
      client: $client
      DateStart: $DateStart
      DateEnd: $DateEnd
      saldo: false
      orderByAscending: $orderByAscending
      fidelityMethod: $fidelityMethod
    ) {
      voucher
      value
      date
      hour
      type
      error
      OBS
      gasstation
      manualInserted
      fidelityMethod
      __typename
    }
  }
`;

export const GET_RESUME_SUPPLYS_EXTRACT_CUSTOMER = gql`
  query extrato($customer: ID!, $DateStart: Date, $DateEnd: Date) {
    resumeSupplysExtractCustomer(
      customer: $customer
      DateStart: $DateStart
      DateEnd: $DateEnd
    ) {
      name
      value
      type
      voucher
    }
  }
`;
export const GET_NOT_USED_SUPPLYS = gql`
  query getNotUsedSupplys(
    $customer: ID!
    $gasstation: [ID]
    $dataInicio: Date
    $dataFim: Date
    $offset: Int
    $limit: Int
    $productgas: [ID]
    $typeVoucher: String
    $client: [ID]
    $page: Int!
    $perPage: Int!
    $orderBy: String
    $orderDirection: ORDER_DIRECTION
    $fidelityMethod: FIDELITY_METHOD_INPUT
    $search: String
    $searchFields: [String]
  ) {
    supplysNotUsed(
      customer: $customer
      gasstation: $gasstation
      dataInicio: $dataInicio
      dataFim: $dataFim
      offset: $offset
      limit: $limit
      productgas: $productgas
      typeVoucher: $typeVoucher
      client: $client
      page: $page
      perPage: $perPage
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
      searchFields: $searchFields
      fidelityMethod: $fidelityMethod
    ) {
      totalDocs
      page
      totalPages
      docs {
        typeVoucher
        voucher
        _id
        discountTotal
        concluded
        value
        valueTotal
        valueTotalWithDiscount
        valido
        rated
        evaluation
        liters
        discount
        createdAd
        cancel
        dateInserted
        dateVenda
        product_diver
        withdrawStore
        liters_diver
        payments_diver
        active
        fidelityMethod
        valueUser
        literUser
        typeChoicePromotion
        typeChoiceUser
        distanceMeters
        productgas {
          _id
          name
        }
        payments {
          _id
          name
          ref
        }
        client {
          _id
          name
          sexo
          age
          birthday
        }
        promotion {
          _id
          name
        }
        gasstation {
          _id
          name
        }
      }
    }
  }
`;

export const GET_PENDING_SUPPLYS = gql`
  query getPendingSupplys(
    $customer: ID!
    $gasstation: [ID]
    $offset: Int
    $limit: Int
    $productgas: [ID]
    $typeVoucher: String
    $client: [ID]
    $page: Int!
    $perPage: Int!
    $orderBy: String
    $orderDirection: ORDER_DIRECTION
    $search: String
    $searchFields: [String]
    $fidelityMethod: FIDELITY_METHOD_INPUT
  ) {
    supplysPending(
      customer: $customer
      gasstation: $gasstation
      offset: $offset
      limit: $limit
      productgas: $productgas
      typeVoucher: $typeVoucher
      client: $client
      page: $page
      perPage: $perPage
      orderBy: $orderBy
      orderDirection: $orderDirection
      search: $search
      searchFields: $searchFields
      fidelityMethod: $fidelityMethod
    ) {
      totalDocs
      page
      totalPages
      docs {
        typeVoucher
        voucher
        _id
        discountTotal
        concluded
        value
        valueTotal
        valueTotalWithDiscount
        distanceMeters
        valido
        rated
        evaluation
        liters
        discount
        createdAd
        cancel
        dateInserted
        dateVenda
        product_diver
        withdrawStore
        liters_diver
        payments_diver
        active
        fidelityMethod
        valueUser
        literUser
        typeChoicePromotion
        typeChoiceUser
        productgas {
          _id
          name
        }
        payments {
          _id
          name
          ref
        }
        client {
          _id
          name
          sexo
          age
          birthday
        }
        promotion {
          _id
          name
        }
        gasstation {
          _id
          name
        }
      }
    }
  }
`;

export const GET_EXTRACT_CUSTOMER = gql`
  query getExtractBusines(
    $customer: ID!
    $gasstation: [ID]
    $search: String
    $searchFields: [String]
    $page: Int!
    $perPage: Int!
    $dateStart: Date
    $dateEnd: Date
    $orderBy: String
    $orderDirection: ORDER_DIRECTION
    $fidelityMethod: FIDELITY_METHOD
  ) {
    supplyExtractCustomer(
      customer: $customer
      gasstation: $gasstation
      search: $search
      searchFields: $searchFields
      page: $page
      perPage: $perPage
      dateStart: $dateStart
      dateEnd: $dateEnd
      orderBy: $orderBy
      orderDirection: $orderDirection
      fidelityMethod: $fidelityMethod
    ) {
      docs {
        _id
        storeName
        storeAccumulatedTotal
        storeBonusTotal
        storeTotal
        storeDebtTotal
        expiredValue
        storeFinalBalance
      }
      page
      totalDocs
      perPage
      totalPages
    }
  }
`;

export const GET_PRODUCT_RESCUE_BY_CLIENT_REPORT = gql`
  query GetProductRescueByClientReport(
    $customer: ID!
    $client: ID
    $gasstations: [ID]
    $stores: [ID]
    $product: [ID]
    $dataInicio: Date!
    $dataFim: Date!
    $status: String
  ) {
    productRescueByClientReport(
      customer: $customer
      client: $client
      gasstation: $gasstations
      store: $stores
      product: $product
      dataInicio: $dataInicio
      dataFim: $dataFim
      status: $status
    ) {
      _id
      client {
        _id
        name
      }
      empresa {
        _id
        name
        type
      }
      quantidade
      produto {
        _id
        name
      }
      dataResgate
      status
      dataRetirada
    }
  }
`;
